<template>
  <add-edit-dialog>
    <div class="page-title">新增客户</div>
    <div class="page-buttons">
      <crm-button :text="'保存'" @click="customFormSubmit()"> </crm-button>
      <crm-button :buttonType="'plain'" :text="'取消'" @click="handleGoBack()">
      </crm-button>
    </div>
    <div class="page-add-custom">
      <add-form ref="form"></add-form>
    </div>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import * as utils from '@/scripts/utils';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmButton from '@/components/base/crmButton';
import AddForm from './form';

export default {
  components: {
    AddEditDialog,
    CrmButton,
    AddForm,
  },
  methods: {
    ...mapActions({
      addCustom: 'customer/addCustom',
    }),
    handleGoBack() {
      this.$emit('closeAddCustom');
    },
    /**
     * 创建新客户
     */
    customFormSubmit() {
      this.$refs.form.handleReturnData().then((params) => {
        if (params) {
          this.addCustom({
            ...params,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '新增成功！',
            });
            // if (res.data.code === '200') {
            this.$emit('saveAddCustom');
            // }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
@import '~@/styles/const.less';

.page-title {
  height: 33px;
  margin-bottom: 10px;
  font-size: @font-size--max;
  color: @color--info;
  line-height: 33px;
  line-height: 33px;
}
.page-add-custom {
  overflow: auto;
  .add-custom-form {
    padding-left: 100px;
  }
}
</style>
